<template>
  <component
    :is="component"
    :field="field"
    :value="value"
    @input="$emit('input', $event)"
  />
</template>

<script>
export default {
  name: 'ExtraField',
  props: {
    field: {
      type: Object,
    },
    value: {},
  },
  computed: {
    component() {
      let component = null
      component = () =>
        import(
          /* webpackChunkName: "extra_field" */ `./${this.field.type.snake2Pascal()}Field`
        ).catch(
          (component = () =>
            import(/* webpackChunkName: "extra_field" */ './TextField')),
        )
      return component
    },
  },
}
</script>

<style scoped></style>
